import { render } from "./OrderConfirmation.vue?vue&type=template&id=27a018da&scoped=true"
import script from "./OrderConfirmation.vue?vue&type=script&lang=js"
export * from "./OrderConfirmation.vue?vue&type=script&lang=js"

import "./OrderConfirmation.vue?vue&type=style&index=0&id=27a018da&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a018da"]])

export default __exports__